import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';

@Directive({
    selector: '[appHasRole]',
    standalone: false
})
export class HasRoleDirective{

  @Input()
  set appHasRole(values: string[]) {
		const condition : boolean = this.condition(values);
		condition
		? this.viewContainer.createEmbeddedView(this.templateRef)
		: this.viewContainer.clear();
  }

  constructor(private templateRef: TemplateRef<any>,
              private viewContainer: ViewContainerRef,
							private keycloakServ : KeycloakService){}

	condition(values : string[]) : boolean {
		const listOfRoles : string[] = this.keycloakServ.getUserRoles();
		for (let i = 0; i < listOfRoles.length; i++)
			for (let j = 0; j < values.length; j++)
				if(listOfRoles[i] === values[j])
					return true;
		return false;
	}
}
